import { render, staticRenderFns } from "./CardFilterDefault.vue?vue&type=template&id=0b1727b5&scoped=true&"
import script from "./CardFilterDefault.vue?vue&type=script&lang=js&"
export * from "./CardFilterDefault.vue?vue&type=script&lang=js&"
import style0 from "./CardFilterDefault.vue?vue&type=style&index=0&id=0b1727b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1727b5",
  null
  
)

export default component.exports